
<div class="panel-container my-2">
  <div class="pannel-bar">
    <div
      ref="pannel"
      class="panel-item d-flex justify-content-between align-items-center"
      @click="$emit('toggle')"
    >
      <div class="d-flex align-items-center">
        <svg-icon
          aria-label="share"
          class="svg-icon-share stat-item-icon mr-1"
          :icon-name="getIconLabel(isOpen)"
        ></svg-icon>
        <span class="label">{{ getLabel() }}</span>
      </div>
      <div class="d-flex align-items-center">
        <span :class="isValuePresent ? 'label' : 'text-italic'">{{ limiteValue }}</span>
        <div
          v-show="isDeleteBtn && category !== 'deposit'"
          class="btn-delete ml-1"
          @click.stop="$bvModal.show(confirmationUUID)"
        >
          <svg-icon icon-name="ic-corbeille" className="iconeCorbeille"></svg-icon>
        </div>
      </div>
    </div>
  </div>
  <!-- Fenêtre modale de confirmation optionnelle -->
  <b-modal
    :id="confirmationUUID"
    centered
    hide-footer
    hide-header
    no-hide-backdrop
    no-close-on-backdrop
    no-close-on-esc
  >
    <div class="compteClair modale-container">
      <div v-html="jel_replaceTokens(content.confirmationSupp)"></div>
      <div class="modale-pannel-btn">
        <b-button class="btn btn-primaire-secondaire" @click="$bvModal.hide(confirmationUUID)">
          {{ content.libBtnAnnuler }}
        </b-button>
        <b-button
          class="btn btn-primaire-limite"
          @click="$bvModal.hide(confirmationUUID), deleteLimit()"
        >
          {{ content.libBtnModaleConfirmer }}
        </b-button>
      </div>
    </div>
  </b-modal>

  <div class="panel-item-limit" @close="$emit('toggle')">
    <transition name="slide-down">
      <LimitForm
        v-if="isOpen"
        ref="limitform"
        :category="category"
        :period="period"
        :content="content"
        @success-limitSet="getlimitMessageAndCloseForm"
      />
    </transition>
  </div>
  <MessageMel
    v-show="isAlerteExist"
    class="info-text px-2 pt-2 pb-0"
    :content="contentMessageMel.alert"
  />
</div>
